export default {"src":"/_next/static/media/credit-badge-black-friday.270221ba.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};